<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quotationType" v-model="cargoForm.quotationType" :label="labels.quotationType" item-text="label" item-value="value" data-vv-name="quotationType" :data-vv-as="labels.quotationType" :error-messages="errors.collect('quotationType')" v-validate="'required'" @change="doQuotationType"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-int-mask="{intScale: 11}" v-model="cargoForm.masterProposalNo" :label="labels.masterProposalNo" type="tel" :error-messages="errors.collect('masterProposalNo')" data-vv-name="masterProposalNo" :data-vv-as="labels.masterProposalNo" v-validate="'numeric'" @change="getMasterProposal(cargoForm.masterProposalNo, true)" :disabled="disableMasterProposalNo">
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                  <v-icon color="info" @click="doShowMasterProposals" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.product" v-model="cargoForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" v-validate="'required'" @input="doProduct" :disabled="masterDisabledField"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12></v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.busCls" v-model="cargoForm.busCls" :label="labels.busCls" item-text="label" item-value="value" data-vv-name="busCls" :data-vv-as="labels.busCls" :error-messages="errors.collect('busCls')" v-validate="'required'" :loading="busClsLoading" :disabled="masterDisabledField"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs7 v-if="isStaff">
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['cargoQuoteAcceptDate'])" @input="doAcceptDate" ></cal-picker>
                  <!-- cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required|accept_today_date'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['cargoQuoteAcceptDate'])" @input="doAcceptDate" :max="minStartDate"></cal-picker -->
                </v-flex>
                 <v-flex xs7 v-else>
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['cargoQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['cargoQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="minStartDate"></cal-picker-->
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="acceptTime" :label="labels.acceptTime" v-validate="'required'" :data-vv-as="labels.acceptTime" data-vv-name="acceptTime" :error-messages="errors.collect('acceptTime')" :readonly="!checkAccess(['cargoQuoteAcceptDate'])" @input="doAcceptDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="cargoForm.startDate" :label="comDateOptional? labels.startDate:labels.startDateMand" v-validate="comDateOptional ? optionalStartDateValidation : startDateValidation" :data-vv-as="labels.startDate" data-vv-name="startDate" :error-messages="errors.collect('startDate')" @input="doStartDate" :min="this.acceptDate" :max="maxStartDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="cargoForm.endDate" :label="comDateOptional? labels.endDate:labels.endDateMand" v-validate="comDateOptional ?'' : endDateValidation" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" :min="this.cargoForm.startDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.comdty" v-model="cargoForm.comdty" :label="labels.comdty" item-text="label" item-value="value" data-vv-name="comdty" :data-vv-as="labels.comdty" :error-messages="errors.collect('comdty')" v-validate="'required'" :loading="comdtyLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.pack" v-model="cargoForm.pack" :label="labels.pack" item-text="label" item-value="value" data-vv-name="pack" :data-vv-as="labels.pack" :error-messages="errors.collect('pack')" v-validate="'required'" :loading="packLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field ref="si" v-num-mask v-model="cargoForm.si" :label="labels.si" type="tel" :error-messages="errors.collect('si')" data-vv-name="si" :data-vv-as="labels.si" v-validate="'required|mask_decimal:2|mask_min_value:1|mask_max_value:99999999.99'" @change="calculateDeclaredSumInsured"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="printSi" v-model="cargoForm.printSi" :label="labels.printSi" item-text="label" item-value="value" data-vv-name="printSi" :data-vv-as="labels.printSi" :error-messages="errors.collect('printSi')" v-validate="'required'" :disabled="masterDisabledField"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field ref="siUplift" v-num-mask v-model="cargoForm.siUplift" :label="labels.siUplift" type="tel" :error-messages="errors.collect('siUplift')" data-vv-name="siUplift" :data-vv-as="labels.siUplift" v-validate="'required|mask_min_value:0|mask_max_value:100'" append-icon="mdi-percent" @change="calculateDeclaredSumInsured"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.currRates" v-model="cargoForm.siCurr" :label="labels.siCurr" item-text="label" item-value="value" data-vv-name="siCurr" :data-vv-as="labels.siCurr" :error-messages="errors.collect('siCurr')" v-validate="'required'" :loading="currRateLoading" :disabled="masterDisabledField"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field ref="tolerance" v-num-mask="{negative: true}" v-model="cargoForm.tolerance" :label="labels.tolerance" type="tel" :error-messages="errors.collect('tolerance')" data-vv-name="tolerance" :data-vv-as="labels.tolerance" v-validate="'required|mask_min_value:-100|mask_max_value:100'" append-icon="mdi-percent" @change="calculateDeclaredSumInsured"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.currRates" v-model="cargoForm.billCurr" :label="labels.billCurr" item-text="label" item-value="value" data-vv-name="billCurr" :data-vv-as="labels.billCurr" :error-messages="errors.collect('billCurr')" v-validate="'required'" :loading="currRateLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg12>
              <v-textarea :label="labels.subjectMatter" v-model="cargoForm.subjectMatter" :error-messages="errors.collect('subjectMatter')" v-validate="'subjectMatter'" data-vv-name="subjectMatter" :data-vv-as="labels.subjectMatter" prepend-icon="mdi-comment-text" auto-grow></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div class="body-2">{{labels.cpInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.campaign" v-model="cargoForm.campaign" :label="labels.campaign" item-text="label" item-value="value" data-vv-name="campaign" :data-vv-as="labels.campaign" :error-messages="errors.collect('campaign')" clearable :loading="campaignLoading" @input="doCampaign"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.promotion" v-model="cargoForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable :loading="promotionLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
    <v-dialog v-model="showMasterProposals" width="1280px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Contract/Master Proposals
          <v-spacer></v-spacer>
          <v-btn flat icon @click="showMasterProposals = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form>
              <v-expansion-panel expand :value="[true]">
                <v-expansion-panel-content>
                  <div slot="header">
                    <v-icon>mdi-filter-variant</v-icon> Filters
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xl3 lg4 xs6>
                            <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                          </v-flex>
                          <v-flex xl3 lg4 xs6>
                            <v-text-field v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                          </v-flex>
                          <v-flex xl3 lg4 xs6>
                            <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                          </v-flex>
                          <v-flex xl3 lg4 xs6>
                            <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" flat="flat" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table :headers="this.headers" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.proposalNo }}</td>
                <td>{{ props.item.polNo }}</td>
                <td>{{ props.item.intermediaryName }}</td>
                <td>{{ props.item.appName }}</td>
                <td>{{ props.item.siDeclared }}</td>
                <td>{{ props.item.createdDate }}</td>
                <td align='center'>
                  <v-btn icon slot="activator" color="primary" flat type="submit" @click.prevent="doSelectMasterProposal(props.item.proposalNo)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { QUOTE_CARGO_PARAM, QUOTE_CARGO_PARAM_GENERAL, QUOTE_CARGO_PARAM_CLAUSE, AGENCY_QUOTATION_LIFECYCLE, QUOTE_CARGO_GENERAL_SIDECLARED, QUOTE_CARGO_GENERAL_LOADMASTER } from '@/store/types'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { removeTime, setEndTime, formatDisplayTime, formatDisplayDateTime2 } from '@/utils/date'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import toDate from 'date-fns/toDate'
import isAfter from 'date-fns/isAfter'
import addYears from 'date-fns/addYears'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import { quotationType, printSi } from '@/const/underwriting/cargo'
import { removeFormatNumber } from '@/utils/number'
import { extractRecord } from '@/utils/extract'
import * as TableConst from '@/mixins/table'
import clone from 'clone'

export default {
  data() {
    return {
      labels: {
        quotationType: 'Quotation Type*',
        masterProposalNo: 'Contract/Master Proposal No.',
        product: 'Product*',
        busCls: 'Business Class*',
        comdty: 'Commodity*',
        pack: 'Packing Type*',
        si: 'Sum Insured/Limit per Conveyance*',
        tolerance: 'Tolerance on Credit Amount % (+/-)',
        siCurr: 'Sum Insured Currency*',
        billCurr: 'Billing Currency*',
        siUplift: 'Sum Insured Uplift %',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        subjectMatter: 'Subject Matter',
        startDate: 'Commencement Date',
        endDate: 'Expiry Date',
        startDateMand: 'Commencement Date*',
        endDateMand: 'Expiry Date*',
        printSi: 'Print SI*',
        cpInfo: 'Campaign/Promotion',
        campaign: 'Campaign',
        promotion: 'Promotion'
      },
      cargoForm: {
        quotationType: undefined,
        masterProposalNo: undefined,
        product: undefined,
        busCls: undefined,
        comdty: undefined,
        pack: undefined,
        si: undefined,
        tolerance: undefined,
        siCurr: undefined,
        billCurr: undefined,
        siUplift: undefined,
        acceptDate: undefined,
        subjectMatter: undefined,
        startDate: undefined,
        endDate: undefined,
        printSi: undefined,
        siDeclared: undefined,
        campaign: undefined,
        promotion: undefined
      },
      busClsLoading: false,
      comdtyLoading: false,
      packLoading: false,
      currRateLoading: false,
      masterProposalLoading: false,
      campaignLoading: false,
      promotionLoading: false,
      showMasterProposals: false,
      headers: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Intermediary', value: 'interName' },
        { text: 'Applicant Name', value: 'appName' },
        { text: 'Declared Sum Insured', sortable: false, value: 'siDeclared' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      filtersLabel: {
        proposalNo: 'Proposal No.',
        polNo: 'Policy No.',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To'
      },
      filters: {
        proposalNo: null,
        polNo: null,
        entryFrom: null,
        entryTo: null
      },
      totalItems: 0,
      acceptDate: undefined,
      acceptTime: undefined
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData()
    },
    'pagination.page': function (value) {
      this.fetchData()
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData()
    },
    'pagination.sortBy': function (value) {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quoteParam() {
      return this.$store.state.agency.quotation.cargoParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    isStaff() {
      return this.$store.state.agency.quotationSettings.isStaff
    },
    startDateValidation() {
      // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'required|start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    },
    optionalStartDateValidation() {
      // return 'start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    },
    endDateValidation() {
      return 'required|start_enddate:' + this.cargoForm.startDate
    },
    quotationType() {
      let result = []
      Object.keys(quotationType).forEach(function (key) {
        const label = quotationType[key]
        result.push({
          label: label,
          value: key
        })
      })
      return result
    },
    printSi() {
      let result = []
      Object.keys(printSi).forEach(function (key) {
        const label = printSi[key]
        result.push({
          label: label,
          value: key
        })
      })
      return result
    },
    disableMasterProposalNo() {
      if (this.cargoForm.quotationType !== 'I') {
        return true
      } else {
        return false
      }
    },
    masterDisabledField() {
      if (this.cargoForm.masterProposalNo && this.cargoForm.masterProposalNo !== undefined) {
        return true
      } else {
        return false
      }
    },
    selectedProduct() {
      if (this.cargoForm.product) {
        return extractRecord(this.quoteParam.product, this.cargoForm.product)
      } else {
        return null
      }
    },
    comDateOptional() {
      if (this.selectedProduct && this.selectedProduct.comDateOpt) {
        return true
      }
      return false
    },
    proceedLoading() {
      if (this.busClsLoading || this.comdtyLoading || this.packLoading || this.currRateLoading || this.masterProposalLoading || this.campaignLoading || this.promotionLoading) {
        return true
      } else {
        return false
      }
    },
    daysBeforeCover() {
      if (this.cargoForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.cargoForm.product)
        if (productParam) {
          return productParam.maxDaysBeforeCover
        }
      }
      return undefined
    },
    minStartDate() {
      return new Date()
    },
    maxStartDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    backDateDays() {
      const product = this.selectedProduct
      if (product) {
        return product.backDateAcceptDays
      } else {
        return null
      }
    },
    backDateLimit() {
      if (this.backDateDays !== null || this.backDateDays !== undefined) {
        if (this.backDateDays === 0) {
          return new Date()
        } else {
          return subDays(new Date(), this.backDateDays)
        }
      } else return null
    },
    acceptDateValidation() {
      // const result = 'required|accept_back_date:' + this.backDateDays + '|accept_start_date:' + this.cargoForm.startDate + '|accept_today_date'
      // return result
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_today_date'
      return 'required|accept_back_date:' + this.backDateDays
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.cargoForm.quotationType = this.globalCommonForm.quotationType
      this.cargoForm.masterProposalNo = this.globalCommonForm.masterProposalNo
      this.cargoForm.product = this.globalCommonForm.product
      this.cargoForm.busCls = this.globalForm.busCls
      this.cargoForm.tariff = this.globalForm.tariff
      this.cargoForm.comdty = this.globalForm.comdty
      this.cargoForm.pack = this.globalForm.pack
      this.cargoForm.si = this.globalForm.si
      this.cargoForm.tolerance = this.globalForm.tolerance
      this.cargoForm.siUplift = this.globalForm.siUplift
      this.cargoForm.siCurr = this.globalForm.siCurr
      this.cargoForm.billCurr = this.globalCommonForm.billCurr
      if (this.globalCommonForm.acceptDate) {
        this.cargoForm.acceptDate = toDate(this.globalCommonForm.acceptDate)
        // Need break down acceptDate into date and time for input
        if (this.cargoForm.acceptDate) {
          this.acceptDate = this.cargoForm.acceptDate
          this.acceptTime = formatDisplayTime(this.cargoForm.acceptDate)
        }
      }
      if (this.globalCommonForm.startDate) {
        this.cargoForm.startDate = toDate(this.globalCommonForm.startDate)
      }
      if (this.globalCommonForm.endDate) {
        this.cargoForm.endDate = toDate(this.globalCommonForm.endDate)
      }
      this.cargoForm.campaign = this.globalCommonForm.campaign
      this.cargoForm.promotion = this.globalCommonForm.promotion
      this.cargoForm.subjectMatter = this.globalForm.subjectMatter
      this.cargoForm.siDeclared = this.globalForm.siDeclared
      this.cargoForm.siBalance = this.globalForm.siBalance
      this.cargoForm.printSi = this.globalForm.printSi

      if (!this.cargoForm.quotationType) {
        this.cargoForm.quotationType = 'I'
      }

      if (this.cargoForm.masterProposalNo) {
        this.getMasterProposal(this.cargoForm.masterProposalNo, false)
      }
      // Check if there are already values in vuex form or if it is a fresh entry
      // For this case, we will just use product as an indicator (for review, there is already value saved)
      if (!this.cargoForm.product) {
        if (this.quoteParam.product && this.quoteParam.product.length > 0) {
          // This is to load 1st value if its a fresh quotation
          this.cargoForm.product = this.quoteParam.product[0].value
          this.doProduct()
        }
        this.$store.commit(QUOTE_CARGO_PARAM_GENERAL)
      } else {
        // If there are already values in vuex, we will check if we still need to load Cargo General Screen params
        if (!this.quoteParam.generalLoaded) {
          this.doProduct()
          this.$store.commit(QUOTE_CARGO_PARAM_GENERAL)
        }
      }
    },
    doQuotationType() {
      this.cargoForm.masterProposalNo = undefined
      if (this.cargoForm.quotationType !== 'I') {
        this.cargoForm.siBalance = this.cargoForm.siDeclared
      } else {
        this.cargoForm.siBalance = null
      }
      const commitResult = {
        siDeclared: this.cargoForm.siDeclared,
        siBalance: this.cargoForm.siBalance
      }
      this.$store.commit(QUOTE_CARGO_GENERAL_SIDECLARED, commitResult)
    },
    doProduct() {
      this.getBusCls()
      this.getComdty()
      this.getPack()
      this.doAcceptDate()
      if (this.cargoForm.acceptDate && this.cargoForm.product) {
        this.getCampaign()
      } else {
        this.cargoForm.campaign = undefined
        this.doCampaign()
      }
    },
    doStartDate() {
      if (this.cargoForm.startDate) {
        // Add 1 year to end Date
        let endDate = addYears(this.cargoForm.startDate, 1)
        endDate = subDays(endDate, 1)
        this.cargoForm.endDate = endDate
      }
    },
    async getBusCls() {
      const apiURI = this.$store.state.agency.quotation.menu.busCls
      if (apiURI) {
        try {
          this.busClsLoading = true
          const expand = {
            product: this.cargoForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              busCls: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
          }
          this.busClsLoading = false

          // Defaulting for busCls (Default 1st if no value was set)
          if (!this.cargoForm.busCls && this.cargoForm.product && this.quoteParam.busCls && this.quoteParam.busCls.length > 0) {
            this.cargoForm.busCls = this.quoteParam.busCls[0].value
          }

          if (this.cargoForm.busCls && this.quoteParam.busCls && this.quoteParam.busCls.length > 0) {
            // Check if the current busCls value is still valid
            let busClsIsValid = false
            for (var i = 0; i < this.quoteParam.busCls.length; i++) {
              const busCls = this.quoteParam.busCls[i]
              if (busCls.value === this.cargoForm.busCls) {
                busClsIsValid = true
                break
              }
            }
            // Invalid BusCls (reset to undefined)
            if (!busClsIsValid) {
              this.cargoForm.busCls = undefined
              this.doBusCls()
              this.$store.commit(QUOTE_CARGO_PARAM_CLAUSE, false)
            } else {
              this.doBusCls()
              this.$store.commit(QUOTE_CARGO_PARAM_CLAUSE, false)
            }
          } else {
            this.cargoForm.busCls = undefined
            this.doBusCls()
            this.$store.commit(QUOTE_CARGO_PARAM_CLAUSE, false)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.busClsLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doBusCls() {
      this.getTariff()
    },
    async getTariff() {
      // Defaulting for tariff (Based on buscls param)
      if (!this.cargoForm.tariff && this.cargoForm.busCls && this.quoteParam.busCls && this.quoteParam.busCls.length > 0) {
        const busClsParam = this.quoteParam.busCls.filter(busCls => busCls.value === this.cargoForm.busCls)
        if (busClsParam) {
          this.cargoForm.tariff = busClsParam[0].defTariff
        }
      }
    },
    async getComdty() {
      const apiURI = this.$store.state.agency.quotation.menu.comdty
      if (apiURI) {
        this.comdtyLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              comdty: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.comdtyLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.comdtyLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getPack() {
      const apiURI = this.$store.state.agency.quotation.menu.pack
      if (apiURI) {
        this.packLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              pack: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.packLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.packLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doAcceptDate() {
      // Format Accept Date
      if (this.checkAccess(['cargoQuoteAcceptDate'])) {
        if (this.acceptDate && this.acceptTime && this.acceptTime.length === 5) {
          const hr = this.acceptTime.substring(0, 2)
          const min = this.acceptTime.substring(3, 5)
          this.acceptDate = toDate(this.acceptDate)
          this.acceptDate.setHours(hr)
          this.acceptDate.setMinutes(min)
          this.cargoForm.acceptDate = this.acceptDate
        }
      }
      this.getCurrRate()

      if (this.cargoForm.product && this.cargoForm.acceptDate) {
        this.getCampaign()
      } else {
        this.cargoForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getCurrRate() {
      const apiURI = this.$store.state.agency.quotation.menu.currRate
      if (apiURI) {
        try {
          this.currRateLoading = true
          const tempAcceptDate = formatDisplayDateTime2(this.cargoForm.acceptDate)
          const expand = {
            effDate: tempAcceptDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              currRates: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.currRateLoading = false

            if (this.cargoForm.siCurr && this.quoteParam.currRates && this.quoteParam.currRates.length > 0) {
              // Check if the current sum insured currency value is still valid
              let siCurrIsValid = false
              for (var i = 0; i < this.quoteParam.currRates.length; i++) {
                const siCurr = this.quoteParam.currRates[i]
                if (siCurr.value === this.cargoForm.siCurr) {
                  siCurrIsValid = true
                  break
                }
              }
              // Invalid sum insured currency (reset to undefined)
              if (!siCurrIsValid) {
                this.cargoForm.siCurr = undefined
              }
            }

            if (this.cargoForm.billCurr && this.quoteParam.currRates && this.quoteParam.currRates.length > 0) {
              // Check if the current billing currency value is still valid
              let billCurrIsValid = false
              for (var j = 0; j < this.quoteParam.currRates.length; j++) {
                const billCurr = this.quoteParam.currRates[j]
                if (billCurr.value === this.cargoForm.billCurr) {
                  billCurrIsValid = true
                  break
                }
              }
              // Invalid billing currency (reset to undefined)
              if (!billCurrIsValid) {
                this.cargoForm.billCurr = undefined
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.currRateLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async calculateDeclaredSumInsured() {
      if (this.cargoForm.si != null && this.cargoForm.tolerance != null && this.cargoForm.siUplift != null) {
        const apiUrl = this.$store.state.agency.quotation.menu.calcDeclaredSi
        if (apiUrl) {
          try {
            // Unmask
            this.$refs.si.$el.cleave.setRawValue(this.cargoForm.si)
            this.$refs.tolerance.$el.cleave.setRawValue(this.cargoForm.tolerance)
            this.$refs.siUplift.$el.cleave.setRawValue(this.cargoForm.siUplift)
            const unMaskSi = this.$refs.si.$el.cleave.getRawValue()
            const unMaskTolerance = this.$refs.tolerance.$el.cleave.getRawValue()
            const unMaskSiUplift = this.$refs.siUplift.$el.cleave.getRawValue()
            const siBalance = this.cargoForm.siBalance
            const printSi = this.cargoForm.printSi
            const siDeclaredObj = {
              si: unMaskSi,
              tolerance: unMaskTolerance,
              siUplift: unMaskSiUplift,
              siBalance: siBalance,
              printSi: printSi
            }
            const result = await this.$http.post(apiUrl, siDeclaredObj)
            if (result.data) {
              const { data } = result.data
              this.cargoForm.siDeclared = data
              this.$validator.reset()
            } else {
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.cargoForm.siDeclared = undefined
              this.cargoForm.si = undefined
              this.fieldMessage(data)
            }
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        this.cargoForm.siDeclared = null
      }
      if (this.cargoForm.quotationType !== 'I') {
        this.cargoForm.siBalance = this.cargoForm.siDeclared
      } else {
        this.cargoForm.siBalance = null
      }
      const commitResult = {
        siDeclared: this.cargoForm.siDeclared,
        siBalance: this.cargoForm.siBalance
      }
      this.$store.commit(QUOTE_CARGO_GENERAL_SIDECLARED, commitResult)
    },
    async getMasterProposal(proposalNo, defaultValues) {
      if (proposalNo) {
        const apiURI = this.$store.state.agency.quotation.menu.getMasterProposal
        if (apiURI) {
          this.masterProposalLoading = true
          try {
            const intermediary = this.globalCommonForm.intermediary
            const expand = {
              masterProposalNo: removeFormatNumber(proposalNo),
              intermediary: intermediary
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data && defaultValues === true) {
              this.$store.commit(QUOTE_CARGO_GENERAL_LOADMASTER, result.data)
              this.cargoForm.product = this.globalCommonForm.product
              this.cargoForm.busCls = this.globalForm.busCls
              this.cargoForm.tariff = this.globalForm.tariff
              this.cargoForm.comdty = this.globalForm.comdty
              this.cargoForm.pack = this.globalForm.pack
              this.cargoForm.tolerance = this.globalForm.tolerance
              this.cargoForm.siUplift = this.globalForm.siUplift
              this.cargoForm.siCurr = this.globalForm.siCurr
              this.cargoForm.billCurr = this.globalCommonForm.billCurr
              if (this.globalCommonForm.acceptDate) {
                this.cargoForm.acceptDate = toDate(this.globalCommonForm.acceptDate)
              }
              if (this.globalCommonForm.startDate) {
                this.cargoForm.startDate = toDate(this.globalCommonForm.startDate)
              }
              if (this.globalCommonForm.endDate) {
                this.cargoForm.endDate = toDate(this.globalCommonForm.endDate)
              }
              this.cargoForm.subjectMatter = this.globalForm.subjectMatter
              this.cargoForm.siBalance = this.globalForm.siBalance
              this.cargoForm.printSi = this.globalForm.printSi
              if (this.cargoForm.product) {
                this.doProduct()
              }
              this.cargoForm.si = undefined
              this.calculateDeclaredSumInsured()
              this.masterProposalLoading = false
              this.$validator.reset()
              this.$snotify.success('Contract/Master Proposal Selected')
            } else if (result.data && defaultValues === false) {
              this.cargoForm.siBalance = result.data.cargo.siBalance
              this.masterProposalLoading = false
            } else {
              this.cargoForm.masterProposalNo = undefined
              this.masterProposalLoading = false
              this.$snotify.error('Invalid Contract/Master Proposal No.')
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
              this.notify(data)
            }
            this.cargoForm.masterProposalNo = undefined
            this.masterProposalLoading = false
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        this.cargoForm.product = undefined
        this.cargoForm.busCls = undefined
        this.cargoForm.tariff = undefined
        this.cargoForm.comdty = undefined
        this.cargoForm.pack = undefined
        this.cargoForm.tolerance = undefined
        this.cargoForm.siUplift = undefined
        this.cargoForm.siCurr = undefined
        this.cargoForm.billCurr = undefined
        this.cargoForm.acceptDate = undefined
        this.cargoForm.startDate = undefined
        this.cargoForm.endDate = undefined
        this.cargoForm.subjectMatter = undefined
        this.cargoForm.siBalance = undefined
        this.cargoForm.printSi = undefined
        this.cargoForm.si = undefined
      }
    },
    async getCampaign() {
      const apiURI = this.$store.state.agency.quotation.menu.campaign
      if (apiURI) {
        try {
          const expand = {
            product: this.cargoForm.product,
            intermediary: this.globalCommonForm.intermediary,
            acceptDate: formatDisplayDateTime2(this.cargoForm.acceptDate)
          }
          this.campaignLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              campaign: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
          }
          this.campaignLoading = false

          if (this.cargoForm.campaign && this.quoteParam.campaign && this.quoteParam.campaign.length > 0) {
            // Check if the current campaign value is still valid
            let campaignIsValid = false
            for (var i = 0; i < this.quoteParam.campaign.length; i++) {
              const campaign = this.quoteParam.campaign[i]
              if (campaign.value === this.cargoForm.campaign) {
                campaignIsValid = true
                break
              }
            }
            // Invalid Campaign (reset to undefined)
            if (!campaignIsValid) {
              this.cargoForm.campaign = undefined
            } else { }
          } else {
            this.cargoForm.campaign = undefined
          }
          // Do campaign (get promotion)
          this.doCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.campaignLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCampaign() {
      if (this.cargoForm.campaign && this.cargoForm.acceptDate) {
        this.getPromotion()
      } else {
        this.cargoForm.promotion = undefined
      }
    },
    async getPromotion() {
      const apiURI = this.$store.state.agency.quotation.menu.promotion
      if (apiURI) {
        try {
          const expand = {
            campaign: this.cargoForm.campaign,
            acceptDate: formatDisplayDateTime2(this.cargoForm.acceptDate)
          }
          this.promotionLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              promotion: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
          }
          this.promotionLoading = false

          if (this.cargoForm.promotion && this.quoteParam.promotion && this.quoteParam.promotion.length > 0) {
            // Check if the current promotion value is still valid
            let promotionIsValid = false
            for (var i = 0; i < this.quoteParam.promotion.length; i++) {
              const promotion = this.quoteParam.promotion[i]
              if (promotion.value === this.cargoForm.promotion) {
                promotionIsValid = true
                break
              }
            }
            // Invalid Promotion (reset to undefined)
            if (!promotionIsValid) {
              this.cargoForm.promotion = undefined
            }
          } else {
            this.cargoForm.promotion = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.promotionLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.cargoForm.campaign && this.cargoForm.promotion) || (!this.cargoForm.campaign && !this.cargoForm.promotion)) {
            this.calculateDeclaredSumInsured()
            this.$store.dispatch('cargoQuoteGeneral', this.cargoForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
            this.$router.push({ name: 'cargoQuoteShipment' })
          } else {
            this.errorMessage('Please select a promotion if this quotation is participating in a campaign')
            this.promptFieldCheck()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('cargoQuoteGeneral', this.cargoForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    doShowMasterProposals() {
      this.showMasterProposals = true
      this.fetchData()
    },
    async fetchData() {
      const apiUrl = this.$store.state.agency.quotation.menu.masterProposalList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              data.map(row => {
                if (row.createdDate) {
                  row.createdDate = this.formatDate(row.createdDate)
                }
              })
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doSelectMasterProposal(selectedProposalNo) {
      this.cargoForm.masterProposalNo = selectedProposalNo
      this.getMasterProposal(this.cargoForm.masterProposalNo, true)
      this.showMasterProposals = false
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.polNo = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      // Reset to page 1
      this.pagination.page = 1
      this.fetchData()
    }
  },
  created() {
    // Load in local field validation
    // Name must be unique (as it will extend throughout the application)
    this.$validator.extend('quote_cargo_enddate', {
      getMessage(field, args) {
        return `The ${field} cannot be earlier than Start Date.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var startDate = args[0]
          if (startDate) {
            if (isAfter(startDate, value)) return false
            else return true
          } else return true
        } else return true
      }
    })
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin,
    TableConst.default
  ]
}
</script>

<style lang="scss">
</style>
